import React, { Component } from 'react';
import PropTypes from 'prop-types';


import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import IconButton from '@mui/material/IconButton';
import RotateIcon from '@mui/icons-material/Rotate90DegreesCcw';
import Cropper from 'cropperjs';
import Rotation from '../../lib/ai/rotation';
import { Box } from '@mui/material';

let ro:any = false;

const s:any = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: 'background.paper',
  },
  imageList: {
    width: '100%',
    height: 200,
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  imageListItem: {
    width: '100%',
  },
  titleBar: {
    background:
      'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
      'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
  icon: {
    color: 'white',
  },
  imagewrapper: {
    objectFit: "contain",
    width: '100%',
    height: 240,
  },
  previewImage: {
    transformStyle: 'preserve-3D',
    width: '100%',
    height: 250,
  },
  
};

class CardPreview extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      fwopen: false
    };
  }

  componentDidMount() {
    this.initCropper();
    //this.initRotation();
  }

  initCropper = () => {
    const image:any = document.getElementById(this.props.id);
    // v1
    // const cropper = new Cropper(image, {
    //   aspectRatio: 16 / 9,
    //   crop(event) {
    //     console.log(event.detail.x);
    //     console.log(event.detail.y);
    //     console.log(event.detail.width);
    //     console.log(event.detail.height);
    //     console.log(event.detail.rotate);
    //     console.log(event.detail.scaleX);
    //     console.log(event.detail.scaleY);
    //   },
    // });
    //v2
    const cropper = new Cropper(image);
  }

  initRotation = () => {
    let pp = document.getElementById(this.props.id);
    ro = new Rotation(pp,this.props.rotatefn);
  }

  handleRotate = (ev:any) => {
    if(!ro) this.initRotation();
    ro.rotate();
  }

  //function CountryList(props) 
  render(){
    const { id, tile, classes, theme } = this.props;

    return (
      <Box sx={{...s.root}}>
        <ImageList rowHeight={200} gap={1} cols={1} sx={{...s.imageList}}>
          <ImageListItem sx={{...s.imageListItem}}>
            <Box sx={{...s.imagewrapper}}>
              <Box component='img' sx={{...s.previewImage}} id={id} src={tile.img} alt={tile.title} />
            </Box>
            <ImageListItemBar
              title={tile.title}
              position="top"
              actionIcon={
                <IconButton sx={{...s.icon}} onClick={this.handleRotate}>
                  <RotateIcon />
                </IconButton>
              }
              actionPosition="right"
              sx={{...s.titleBar}}
            />
          </ImageListItem>
        </ImageList>
      </Box>
    );
  }
}

CardPreview.propTypes = {
  //classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default CardPreview;
